import React from 'react';
import ProductCard from './ProductCard';
import M1 from "../../Images/M1.jpg";
import M2 from "../../Images/M2.jpg";
import M3 from "../../Images/M3.avif";
import M4 from "../../Images/M4.jpg";
import M5 from "../../Images/M5.jpg";
import M6 from "../../Images/M6.jpg";
import M7 from "../../Images/M7.jpg";
import M8 from "../../Images/M8.avif";
import M9 from "../../Images/M9.webp";
import M10 from "../../Images/M10.jpeg";
import M11 from "../../Images/M11.avif";
import M12 from "../../Images/M12.webp";
import M13 from "../../Images/M13.jpg";
import M14 from "../../Images/M14.avif";
import M15 from "../../Images/M15.webp";
import M16 from "../../Images/M16.avif";
import M17 from "../../Images/M17.webp";
import M18 from "../../Images/M18.webp";
import M19 from "../../Images/M19.jpg";
import M20 from "../../Images/M20.jpg";


const menProducts = [
  { id: 1, image: M1, name: "Men's Sherwani", price: 5999 },
  { id: 2, image: M2, name: "Classic Kurta Set", price: 2999 },
  { id: 3, image: M3, name: "Indo-Western Suit", price: 7499 },
  { id: 4, image: M4, name: "Designer Blazer", price: 8999 },
  { id: 5, image: M5, name: "Traditional Dhoti Kurta", price: 3499 },
  { id: 6, image: M6, name: "Royal Bandhgala", price: 9999 },
  { id: 7, image: M7, name: "Velvet Sherwani", price: 11999 },
  { id: 8, image: M8, name: "Embroidered Nehru Jacket", price: 4499 },
  { id: 9, image: M9, name: "Casual Linen Kurta", price: 1999 },
  { id: 10, image: M10, name: "Wedding Jodhpuri Suit", price: 10499 },
  { id: 11, image: M11, name: "Pathani Suit", price: 2799 },
  { id: 12, image: M12, name: "Chikankari Kurta", price: 3199 },
  { id: 13, image: M13, name: "Zari Work Sherwani", price: 12999 },
  { id: 14, image: M14, name: "Classic Black Tuxedo", price: 8499 },
  { id: 15, image: M15, name: "Maharaja Style Sherwani", price: 15999 },
  { id: 16, image: M16, name: "Cotton Pathani Kurta", price: 2599 },
  { id: 17, image: M17, name: "Printed Festive Kurta", price: 3799 },
  { id: 18, image: M18, name: "Formal Slim-Fit Suit", price: 9499 },
  { id: 19, image: M19, name: "Velvet Jodhpuri Blazer", price: 7999 },
  { id: 20, image: M20, name: "Silk Angrakha Kurta", price: 5299 },
];


function Mclothes() {
  return (
    <div className="product-container">
      {menProducts.map((item) => (
        <ProductCard key={item.id} image={item.image} name={item.name} price={item.price} />
      ))}
    </div>
  );
}

export default Mclothes;
